import { r as registerInstance, c as createEvent, h, g as getElement } from './index-5faac9d7.js';
import { a5 as rangeBasePath, d as EQdsButtonSize, c as EQdsButtonImportance } from './currency-49e0d692.js';
import { g as getCurrentReference } from './range-helpers-582889ff.js';
import { D as isTargetBlank, E as isLinkTypeOnline } from './index-39f51a91.js';
import { o as onDownloadLinkClickGA } from './helper-baea569d.js';
import './path-3461bbf6.js';
import './_commonjsHelpers-7db8bc26.js';
import './analytics-b3108572.js';
import './lodash-7f024380.js';
import './_nodeUtil-549406aa.js';
import './_Stack-cf94d4e7.js';
import './analytics-74fe4f64.js';
import './number-fcf5283d.js';
import './navigation-83d2f79a.js';

const rangeNodeHeaderCss = "@media screen and (max-width: 979px){.range-node-header{text-align:center}}.range-node-header__prev-level-title{font-size:0.875rem;line-height:1.25rem;font-weight:400;color:#626469}:host(:not([dir=\"rtl\"])) .range-node-header__prev-level-title{margin:0 0 0 32px}:host([dir=\"rtl\"]) .range-node-header__prev-level-title{margin:0 32px 0 0}@media screen and (max-width: 979px){:host(:not([dir=\"rtl\"])) .range-node-header__prev-level-title{margin-left:0}:host([dir=\"rtl\"]) .range-node-header__prev-level-title{margin-right:0}}";

const RangeNodeHeader = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.previousNodeSelected = createEvent(this, "previousNodeSelected", 7);
    this.nodeSelected = createEvent(this, "nodeSelected", 7);
    this.handleLinkClick = (event) => {
      if (!this.isPBS)
        return;
      event.preventDefault();
      this.previousNodeSelected.emit();
      this.nodeSelected.emit({
        nodeReference: getCurrentReference(Boolean(this.backUrl), rangeBasePath, this.backUrl, this.isPBS),
      });
    };
    this.backUrl = undefined;
    this.backUrlTitle = undefined;
    this.levelTitle = undefined;
    this.isPBS = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("div", { class: "range-node-header" }, this.backUrl && (h("qds-standalone-link", { size: "small", importance: "standard", href: this.isPBS ? '#' : this.backUrl, onClick: this.handleLinkClick, iconName: "chevron-left" }, this.backUrlTitle)), this.levelTitle && h("h4", { class: "range-node-header__prev-level-title" }, this.levelTitle)));
  }
  get el() { return getElement(this); }
};
RangeNodeHeader.style = rangeNodeHeaderCss;

const softwareModalBodyCss = "@media screen and (min-width: 980px){.pes-links{padding:5px 25px 40px}}.pes-links__row{display:block;border-bottom:1px solid #e7e6e6;margin-bottom:15px;padding:15px 0;font-size:14px}@media screen and (min-width: 980px){.pes-links__row{margin:0}}.pes-links__row:last-child{border-bottom:0}";

const SoftwareModalBody = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.data = [];
    this.ctaItem = undefined;
    this.position = undefined;
  }
  getLinkByType(row) {
    const { url, label, type, target, reference, fileName, docType } = row;
    const attr = isTargetBlank(target) ? { target: '_blank' } : { download: '' };
    const iconName = isLinkTypeOnline(type)
      ? "arrow-top-right-on-square"
      : "arrow-down-tray";
    return (h("qds-standalone-link", Object.assign({ size: EQdsButtonSize.STANDARD, importance: EQdsButtonImportance.STANDARD, class: "pes-links__link", href: url, onClick: () => onDownloadLinkClickGA(row, row, this.position) }, attr, { "data-doc-reference": reference, "data-doc-name": fileName, "data-doc-type": docType, iconName: iconName }), label));
  }
  render() {
    return (h("div", { class: "pes-links" }, this.data.map((row) => {
      return h("div", { class: "pes-links__row" }, this.getLinkByType(row));
    })));
  }
};
SoftwareModalBody.style = softwareModalBodyCss;

export { RangeNodeHeader as pes_range_node_header, SoftwareModalBody as pes_software_modal_body };
